import * as i0 from '@angular/core';
import { EventEmitter, Component, ViewChild, Input, Output, NgModule } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
const _c0 = ["ankRef"];
const _c1 = ["*"];
let AnnouncekitComponent = /*#__PURE__*/(() => {
  class AnnouncekitComponent {
    constructor(ngZone) {
      this.ngZone = ngZone;
      this.onWidgetOpen = new EventEmitter();
      this.onWidgetClose = new EventEmitter();
      this.onWidgetUnread = new EventEmitter();
      this.onWidgetReady = new EventEmitter();
      this.propsValid = true;
      this.widgetHandlers = [];
      this.widgetHandlers = [];
      this.ngZone.runOutsideAngular(() => {
        if (!window[`announcekit`]) {
          window[`announcekit`] = window[`announcekit`] || {
            queue: [],
            push(x) {
              window[`announcekit`].queue.push(x);
            },
            on(n, x) {
              window[`announcekit`].queue.push([n, x]);
            }
          };
          let scripttag;
          scripttag = document.createElement('script');
          scripttag.async = true;
          scripttag.src = `https://cdn.announcekit.app/widget-v2.js`;
          let scr;
          scr = document.getElementsByTagName('script')[0];
          scr.parentNode.insertBefore(scripttag, scr);
        }
      });
    }
    set user(value) {
      if (this.isString(value) || this.isString(this._user)) {
        this.propsValid = false;
        this._user = undefined;
      } else {
        if (!value) {
          this._user = undefined;
        } else {
          this._user = Object.assign({}, value);
        }
      }
    }
    set data(value) {
      if (this.isString(value) || this.isString(this._data)) {
        this.propsValid = false;
        this._data = undefined;
      } else {
        if (!value) {
          this._data = undefined;
        } else {
          this._data = Object.assign({}, value);
        }
      }
    }
    get user() {
      return this._user;
    }
    get data() {
      return this._data;
    }
    ngOnChanges() {
      if (this.propsValid) {
        this.loaded();
      }
      this.propsValid = true;
    }
    loaded() {
      const style = this.widgetStyle;
      const styleParams = {
        badge: {
          style
        },
        line: {
          style
        },
        float: {
          style
        }
      };
      if (this.floatWidget) {
        delete styleParams.badge;
        delete styleParams.line;
      }
      const name = Math.random().toString(36).substring(10);
      this.ngZone.runOutsideAngular(() => {
        window[`announcekit`].push({
          widget: this.widget,
          name,
          version: 2,
          framework: 'angular',
          framework_version: '4.0.0',
          embed: !!this.embedWidget,
          data: this.data,
          user: this.user,
          lang: this.lang,
          labels: this.labels,
          user_token: this.userToken,
          selector: this.elementRef.nativeElement,
          boosters: typeof this.boosters === 'undefined' ? true : this.boosters,
          ...styleParams,
          onInit: initWidget => {
            if (initWidget.conf.name !== name) {
              return initWidget.destroy();
            }
            const ann = window[`announcekit`];
            this.widgetInstance = initWidget;
            this.barBooster = ann.boosters.bar;
            this.modalBooster = ann.boosters.modal;
            this.widgetHandlers.forEach(h => h(initWidget));
            this.widgetHandlers = [];
            if (this.onWidgetUnread) {
              this.onWidgetUnread.emit(this.widgetInstance.state.ui.unreadCount);
            }
            ann.on('widget-open', ({
              widget
            }) => {
              if (widget === initWidget && this.onWidgetOpen) {
                this.onWidgetOpen.emit({
                  widget
                });
              }
            });
            ann.on('widget-close', ({
              widget
            }) => {
              if (widget === initWidget && this.onWidgetClose) {
                this.onWidgetClose.emit({
                  widget
                });
              }
            });
            ann.on('widget-ready', ({
              widget
            }) => {
              if (widget === initWidget && this.onWidgetReady) {
                this.onWidgetReady.emit({
                  widget
                });
              }
            });
          }
        });
      });
    }
    withWidget(fn) {
      return new Promise(res => {
        if (this.widgetInstance) {
          return res(fn(this.widgetInstance));
        } else {
          this.widgetHandlers.push(widget => {
            res(fn(widget));
          });
        }
      });
    }
    unread() {
      return this.withWidget(widget => widget.state.ui.unreadCount);
    }
    instance() {
      return this.withWidget(widget => widget);
    }
    open() {
      this.withWidget(widget => widget.open());
    }
    close() {
      this.withWidget(widget => widget.close());
    }
    isString(obj) {
      return obj !== undefined && obj !== null && obj.constructor === String;
    }
    ngAfterViewInit() {
      if (!(this.user || this.data)) {
        this.loaded();
      }
    }
  }
  AnnouncekitComponent.ɵfac = function AnnouncekitComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || AnnouncekitComponent)(i0.ɵɵdirectiveInject(i0.NgZone));
  };
  AnnouncekitComponent.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: AnnouncekitComponent,
    selectors: [["announcekit"]],
    viewQuery: function AnnouncekitComponent_Query(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 7);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.elementRef = _t.first);
      }
    },
    inputs: {
      widget: "widget",
      user: "user",
      data: "data",
      lang: "lang",
      floatWidget: "floatWidget",
      embedWidget: "embedWidget",
      boosters: "boosters",
      widgetStyle: "widgetStyle",
      userToken: "userToken",
      labels: "labels"
    },
    outputs: {
      onWidgetOpen: "onWidgetOpen",
      onWidgetClose: "onWidgetClose",
      onWidgetUnread: "onWidgetUnread",
      onWidgetReady: "onWidgetReady"
    },
    standalone: false,
    features: [i0.ɵɵNgOnChangesFeature],
    ngContentSelectors: _c1,
    decls: 3,
    vars: 1,
    consts: [["ankRef", ""], [2, "display", "inline", 3, "ngClass"]],
    template: function AnnouncekitComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵelementStart(0, "div", 1, 0);
        i0.ɵɵprojection(2);
        i0.ɵɵelementEnd();
      }
      if (rf & 2) {
        i0.ɵɵproperty("ngClass", ctx.className);
      }
    },
    dependencies: [i1.NgClass],
    encapsulation: 2
  });
  return AnnouncekitComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AnnouncekitModule = /*#__PURE__*/(() => {
  class AnnouncekitModule {}
  AnnouncekitModule.ɵfac = function AnnouncekitModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || AnnouncekitModule)();
  };
  AnnouncekitModule.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: AnnouncekitModule
  });
  AnnouncekitModule.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    imports: [CommonModule]
  });
  return AnnouncekitModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * Public API Surface of announcekit-angular
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AnnouncekitComponent, AnnouncekitModule };
